module.exports = __webpack_public_path__ + "static/media/autosuggest-sparkles.6b1a361f.svg";